const formatISODate = (date) => new Date(+date - date.getTimezoneOffset()*60*1000).toISOString();

export default formatISODate;
